import { render } from "./Trace.vue?vue&type=template&id=4a836c38&scoped=true"
import script from "./Trace.vue?vue&type=script&lang=ts"
export * from "./Trace.vue?vue&type=script&lang=ts"

import "./Trace.vue?vue&type=style&index=0&id=4a836c38&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4a836c38"

export default script